import React, { memo } from 'react';
import type { JSX } from 'react';

type PurchaseLogoProps = {
    color: string,
    height: number,
};

function PurchaseLogo(props: Readonly<PurchaseLogoProps>): JSX.Element {

    const originalWidth: number = 24;
    const originalHeight: number = 24;

    return (
        <svg
            version='1.1'
            id='Layer_1'
            xmlns='http://www.w3.org/2000/svg'
            x='0px'
            y='0px'
            viewBox='0 0 24 24'
            xmlSpace='preserve'
            width={originalWidth * (props.height / originalHeight)}
            height={props.height}
        >
            <g id='Purchase'>
                <g className='st0'>
                    <path 
                        style={{
                            fill: props.color,
                        }}
                        d='m 8.6328006,17.050799 c -0.9259799,0 -1.6751817,0.757619 -1.6751817,1.683599 0,0.92598 0.7492018,1.6836 1.6751817,1.6836 0.9259798,0 1.6836004,-0.75762 1.6836004,-1.6836 0,-0.92598 -0.7576206,-1.683599 -1.6836004,-1.683599 z M 3.5820015,3.582002 v 1.6835997 h 1.6835997 l 3.0304794,6.3892603 -1.1364298,2.062409 c -0.1346879,0.235704 -0.2104499,0.513498 -0.2104499,0.808128 0,0.92598 0.7576197,1.6836 1.6835997,1.6836 H 18.734399 v -1.6836 H 8.9863565 c -0.117852,0 -0.21045,-0.0926 -0.21045,-0.21045 l 0.025254,-0.101016 0.7576199,-1.372134 H 15.83019 c 0.63135,0 1.186937,-0.345138 1.473149,-0.867053 l 3.013644,-5.4632805 c 0.06734,-0.117852 0.101016,-0.260958 0.101016,-0.404064 0,-0.4629899 -0.37881,-0.8417998 -0.8418,-0.8417998 H 7.1259788 L 6.334687,3.582002 Z M 17.050799,17.050799 c -0.925979,0 -1.675181,0.757619 -1.675181,1.683599 0,0.92598 0.749202,1.6836 1.675181,1.6836 0.92598,0 1.6836,-0.75762 1.6836,-1.6836 0,-0.92598 -0.75762,-1.683599 -1.6836,-1.683599 z'
                    />
                </g>
            </g>
        </svg>
    );
}

export default memo(PurchaseLogo);